import { render, staticRenderFns } from "./home-team.vue?vue&type=template&id=e4e4129c&scoped=true&"
import script from "./home-team.vue?vue&type=script&lang=js&"
export * from "./home-team.vue?vue&type=script&lang=js&"
import style0 from "./home-team.vue?vue&type=style&index=0&id=e4e4129c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e4129c",
  null
  
)

export default component.exports